import FooterAddressDto from "dto/components/app-footer/footer-address-dto";

const FooterAddress = ({ title, description, isHeadquarter = false, children }: FooterAddressDto) => {
	return (
		<div className="footer-address">
			<p className="footer-address__title">
				{title}

				{isHeadquarter && " (HQ)"}
			</p>

			{description && <p className="footer-address__description">{description}</p>}

			{children}
		</div>
	);
};

export default FooterAddress;
